/**
 * fixed is different from fixed. 
 * - fixed will put an element position fixed based on its original position.
 * - sticky will put an element fixed based on the user's actions
 *
 * fixed sets an element position fixed based on its original position. 
 * since it's a very simple script, it recalculates on window resize. sticky doesn't since it's a bit more complicated.
 * 
 * Whether or not to fix the elment based on original position:
 * - data-fixed-set-top: true/false
 * - data-fixed-set-left: true/false
 * 
 * What custom value to set the position
 * - data-fixed-to-left: px 
 * - data-fixed-to-right: px 
 * - data-fixed-to-top: px 
 * - data-fixed-to-bottom: px 
 * 
 * Whether to only set fixed starting from
 * - data-fixed-breakpoint-up: px
 * 
 * For example:

	 <a class="button js-fixed" data-fixed-set-left="true" data-fixed-to-bottom="20" data-fixed-breakpoint-up="1024">My Button</a>

 * 
 */

function fixed() {
	const selector = '.js-fixed';

	if ($(selector).length == 0) {
		window.initFixed = function() {
			console.log('NO FIXED CLASS FOUND');
		};
		return;
	}

	function setFixed() {
		$(selector).each((i, el) => {
			const $el = $(el);

			if ($el.data('fixed-breakpoint-up') && window.innerWidth < $el.data('fixed-breakpoint-up')) {
				return;
			}

			$el.css({
				position: 'fixed'
			});

			if ($el.data('fixed-set-top')) {
				$el.css({
					top: $el.offset().top
				});
			}

			if ($el.data('fixed-set-left')) {
				$el.css({
					left: $el.offset().left
				});
			}

			if ($el.data('fixed-to-left')) {
				$el.css({
					left: $el.data('fixed-to-left')
				});
			}

			if ($el.data('fixed-to-right')) {
				$el.css({
					right: $el.data('fixed-to-right')
				});
			}

			if ($el.data('fixed-to-top')) {
				$el.css({
					top: $el.data('fixed-to-top')
				});
			}

			if ($el.data('fixed-to-bottom')) {
				$el.css({
					bottom: $el.data('fixed-to-bottom')
				});
			}
		});
	}

	function unsetFixed() {
		$(selector).each((i, el) => {
			$(el).css({
				position: '',
				top: '',
				bottom: '',
				left: '',
				right: ''
			});
		});
	}

	window.initFixed = function() {
		if ($(selector).length == 0) {
			return;
		}
		console.log('new');
		unsetFixed();
		setFixed();
	};
	window.initFixed();

	// Since resize events can fire at a high rate,
	// the event handler shouldn't execute computationally
	// expensive operations such as DOM modifications.
	// Instead, it is recommended to throttle the event
	// using requestAnimationFrame, setTimeout or customEvent*, as follows:
	// * IMPORTANT: Please note that IE11 needs the customEvent polyfill to function correctly.
	// https://developer.mozilla.org/en-US/docs/Web/Events/resize

	(function() {
		const throttle = function(type, name, obj) {
			obj = obj || window;
			let running = false;
			const func = function() {
				if (running) {
					return;
				}
				running = true;
				requestAnimationFrame(() => {
					obj.dispatchEvent(new CustomEvent(name));
					running = false;
				});
			};
			obj.addEventListener(type, func);
		};

		/* init - you can init any event */
		throttle('resize', 'optimizedResize');
	})();

	// handle event
	window.addEventListener('optimizedResize', initFixed);
}
fixed();
